module.exports = {
    "oh_url": "https://ophubv3.sanarservices.com",
    "ch_url": "https://chsv3.sanarservices.com",
    jwtSecret: "fgxzbmvhgkiteqw135rodjdxff+=sdhbkvnxzm+=",
    encryptedKey: "fsfhjkgweer+12fbmvngdvdfr+==",
    "hms_url": "https://hms.sanar.sa/",
    "cp_url": "https://cpt.sanarservices.com"
}



//////////////////
// WEBPACK FOOTER
// ./config/endpoints.js
// module id = VPkb
// module chunks = 27